import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { ACCENT } from './shared';
import { AttendanceDaily } from './AttendanceDaily';
import { AttendanceMonthly } from './AttendanceMonthly';
import { AttendanceCodeMapping } from './AttendanceCodeMapping';
import { MyAttendance } from './MyAttendance';
import { hasAnyRole } from '../../config/rbac';
const VIEW_LABEL = { daily: 'Daily', monthly: 'Monthly', codes: 'Employee Codes' };
// Admin/HR/Management get the full company-wide Daily/Monthly report (every
// employee) plus the Employee Codes admin tool; everyone else only ever has
// a self-service view of their own month — the backend enforces this too
// (GET /attendance/me/monthly can only ever return the caller's own
// records), this just picks the right UI.
export function AttendanceTab() {
    const canViewAll = hasAnyRole(['Admin', 'HR', 'Management']);
    const [view, setView] = useState('daily');
    const [monthlyCode, setMonthlyCode] = useState(null);
    const openMonthly = (code) => { setMonthlyCode(code); setView('monthly'); };
    if (!canViewAll)
        return _jsx(MyAttendance, {});
    return (_jsxs(Box, { children: [_jsx(Box, { sx: { display: 'flex', gap: 1, mb: 2 }, children: ['daily', 'monthly', 'codes'].map(v => (_jsx(Button, { size: "small", variant: view === v ? 'contained' : 'outlined', onClick: () => (v === 'monthly' ? openMonthly(monthlyCode) : setView(v)), sx: {
                        textTransform: 'none', fontWeight: 600, borderRadius: 1.5, borderColor: ACCENT,
                        bgcolor: view === v ? ACCENT : 'transparent', color: view === v ? 'white' : ACCENT,
                        '&:hover': { bgcolor: view === v ? '#1f2d0e' : '#eef1e4' },
                    }, children: VIEW_LABEL[v] }, v))) }), view === 'daily' && _jsx(AttendanceDaily, { onOpenMonthly: openMonthly }), view === 'monthly' && _jsx(AttendanceMonthly, { initialCode: monthlyCode }), view === 'codes' && _jsx(AttendanceCodeMapping, {})] }));
}
